(() => {
  document.documentElement.classList.add('plw-js');
  const init = (root = document) => {
    root.querySelectorAll('[data-plw-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');
      const close = () => { menu.open = false; summary.focus(); };
      menu.querySelector('[data-plw-close]')?.addEventListener('click', close);
      document.addEventListener('keydown', event => {
        if (menu.open && event.key === 'Escape') { event.preventDefault(); close(); }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!menu.contains(document.activeElement)) menu.open = false; }); });
      document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
    });
    root.querySelectorAll('[data-plw-brand-search]').forEach(input => {
      if (input.dataset.ready) return;
      input.dataset.ready = 'true';
      input.closest('.plw-brand-filter').hidden = false;
      const section = input.closest('.plw-brands');
      const entries = [...section.querySelectorAll('[data-plw-brand]')];
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase();
        let count = 0;
        entries.forEach(entry => { entry.hidden = !entry.dataset.plwBrand.toLocaleLowerCase().includes(query); if (!entry.hidden) count++; });
        section.querySelector('[data-plw-brand-empty]').hidden = count > 0;
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
 const init = (root=document) => root.querySelectorAll('[data-plw-film]').forEach(video => {
  if (video.dataset.ready) return;
  video.dataset.ready='true';
  const button=video.parentElement.querySelector('[data-plw-film-toggle]');
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused=false;
  video.muted=true;
  const update=()=>{button.textContent=video.paused?'Play film':'Pause film';button.setAttribute('aria-label',video.paused?'Play campaign film':'Pause campaign film');};
  const play=()=>{if (!video.src) video.src=video.dataset.src;return video.play().catch(update);};
  button.hidden=false;
  button.addEventListener('click',()=>{userPaused=!video.paused;if(video.paused) play();else video.pause();});
  video.addEventListener('play',update);video.addEventListener('pause',update);
  const preference=()=>{if(motion.matches){video.pause();video.removeAttribute('autoplay');}else if(!userPaused){video.autoplay=true;play();}update();};
  motion.addEventListener('change',preference);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(!motion.matches&&!userPaused)play();});
  preference();
 });
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
